import template from './taskContent.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    task: '<',
  },
};
